import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'env/environment';

@Component({
  selector: 'telus-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent {
  constructor(private router: Router) {}

  navigateToHome(): void {
    this.router.navigateByUrl('/');
  }
}
